import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { PeriodType } from '../widget/date-range.widget.model';

export interface ExtCacheDateItem {
    periodTypeID: PeriodType;
    startDate: string;
    endDate: string;
    isDefault: boolean;
}

export interface CacheDateItem {
    periodType: PeriodType;
    startDate: Date;
    endDate: Date;
    eventDate: Date;
}

class CacheDateItemModelTransformer
    implements ModelTransformer<CacheDateItem, ExtCacheDateItem>
{
    transform(model: ExtCacheDateItem): CacheDateItem {
        const eventDate = new Date(model.endDate || '');
        switch (model.periodTypeID) {
            case PeriodType.MONTH:
                // ensure event date is end of month. api returned month's event date is data-cache-day event date
                eventDate.setDate(1);
                eventDate.setMonth(eventDate.getMonth() + 1);
                eventDate.setDate(0);
                break;
            case PeriodType.WEEK:
            case PeriodType.QUARTER:
            case PeriodType.YEAR:
                break;
        }

        return {
            periodType: model.periodTypeID,
            startDate: new Date(model.startDate || ''),
            endDate: new Date(model.endDate || ''),
            eventDate,
        };
    }
}

export class CacheDateItemModelSetTransformer extends ModelSetTransformer<
    CacheDateItem,
    ExtCacheDateItem
> {
    protected newTransformer(): ModelTransformer<
        CacheDateItem,
        ExtCacheDateItem
    > {
        return new CacheDateItemModelTransformer();
    }

    transform(model: ExtCacheDateItem[]): CacheDateItem[] {
        return super
            .transform(model)
            .sort((a, b) => b.eventDate.getTime() - a.eventDate.getTime());
    }
}

export function validateCacheDate(model: CacheDateItem[]): void {
    const valid =
        model != null &&
        model.length !== 0 &&
        model.find(
            (value) => value.startDate === null || value.eventDate === null,
        ) == null;
    if (!valid) {
        throw new Error('CacheDate not valid');
    }
}
